import callApi from "./callApi";

const trackPageVisit = (
  pageUrl: string,
  pageTitle: string,
  pageCategory?: string,
) => {
  callApi((api) => api.setPageVisit(pageUrl, pageTitle, pageCategory));
};

export default trackPageVisit;
